import { post, fetch, Del, put } from "@/ask/axios";
export default {
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      Nodata: false,
      StartDate: '',
      EndDate: '',
      curTH: '',
      skip: 0,
      pageSize: 20,
      total: 0,
      currentPage: 1,
      ListData: [],

      share: false,
      shareEmail: '',
      OrderNO: '',
      Note: '',
      shareEmailTip: false,
      //日期输入处理,结束日期不能大于开始日期
      pickerBeginDateBefore: {
        disabledDate: time => {
          if (this.EndDate) {
            return time.getTime() > Date.now() || time.getTime() > this.EndDate;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      //日期输入处理，结束日期不能大于开始日期
      pickerBeginDateAfter: {
        disabledDate: time => {
          // console.log("time:" + this.StartDate);
          let startDate = new Date(this.StartDate);
          return time.getTime() < startDate.getTime() || time.getTime() > Date.now();
        }
      },

      //状态列表
      TakeStatus: 0,
      statusOptions: [
        {
          value: 0,
          label: 'Status'
        }, {
          value: 1,
          label: 'Distributing'
        }, {
          value: 2,
          label: 'Waiting'
        }, {
          value: 3,
          label: 'Picking up'
        }, {
          value: 4,
          label: 'Picked up'
        }, {
          value: 5,
          label: 'Delivered'
        }, {
          value: 6,
          label: 'Terminated'
        }, {
          value: 7,
          label: 'Cancel'
        },
      ],

      isDataNone: false, //是否有渠道数据
      isLoading: false, //加载中...
      isData: false,
    }
  },
  created() {
    this.datetime()
    this.getOrdList()
  },
  methods: {
    // 自动赋值一个月期间时间
    datetime() {
      this.EndDate = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
      let StartDate = new Date(new Date().setMonth(this.EndDate.getMonth() - 1))
      this.StartDate = new Date(new Date(new Date(StartDate).toLocaleDateString()).getTime());
    },
    billStatus(status) {
      let arr = [
        "Distributing",
        "Waiting",
        "Picking up",
        "Picked up",
        "Delivered",
        "Terminated",
        "Cancel"
      ]
      return arr[status - 1]
    },
    clkDel(THBillNo) {
      this.$confirm("Are you sure you want to cancel this order?", "", {
        customClass: "custom-message-box", //自定义添加Class
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
        closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
        showCancelButton: true,//去掉取消按钮
        //showClose:false,//去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        this.delApi(THBillNo);
      }).catch(() => { });
      return false;
    },

    delApi(THBillNo) {
      let that = this
      this.api.param = {
        tHBillNo: THBillNo,
      }
      // this.api.url = this.$api03 + "/api/TradeCustomer/PickupOrders/Remove";
      this.api.url = this.$api04 + "/Pickup/api/PickupOrder/Remove";
      fetch(this.api.url, this.api.param).then(res => {
        if (res.IsOK) {
          that.$confirm("Cancel successfully!", "", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            //showClose:false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
            that.getOrdList();
          }).catch(() => {

          });
          return false;
        } else {
          that.$confirm("Cancel failed!", "", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            //showClose:false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => {

          });
          return false;
        }

      });
    },
    goEdit(tH) {
      this.$router.push({ path: '/pickUp/pickUpEdit', query: { thNo: tH } });
    },
    //分页
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getOrdList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOrdList()
    },
    //==============列表================//
    StatusSelect() { //状态选择
      this.currentPage = 1
      this.getOrdList();
    },
    //列表接口
    getOrdList() {
      let that = this
      that.StartDate = !that.StartDate ? '' : new Date(that.StartDate).Format('yyyy-MM-dd 00:00:01')
      that.EndDate = !that.EndDate ? '' : new Date(that.EndDate).Format('yyyy-MM-dd 23:59:59')

      this.api.param = {
        OrderNO: that.OrderNO.replace(/(^\s*)|(\s*$)/g, ""),//单号去掉前后空格
        takeStatus: that.TakeStatus,//订单状态
        startDate: that.StartDate,//下单开始时间
        endDate: that.EndDate,//下单结束时间
        skip: (that.currentPage - 1) * that.pageSize,
        take: that.pageSize
      }
      that.isLoading = true; //加载中...
      that.isDataNone = false; //没有数据查无订单
      that.isData = false; //有数据列表

      // this.api.url = this.$api03 + "/api/TradeCustomer/PickupOrders/Query";
      this.api.url = this.$api04 + "/Pickup/api/PickupOrderQuery/Query";
      fetch(this.api.url, this.api.param).then(res => {
        if (res.IsOK == true) {
          that.isLoading = false;
          that.isData = true;
          if (res.Results) {
            if (res.Results.length < 0 || res.Results.length == 0) {
              that.isDataNone = true;
              that.isDataNone != that.isLoading;
            } else {
              that.isDataNone = false;
            }
          }
        } else {
          that.isLoading = false;
          that.isDataNone = true;
        }

        that.ListData = res.Results
        that.total = res.Total
      });
    },
    shareStart(th) {
      this.share = true
      this.curTH = th
    },
    EmailBlur() {
      var emailReg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!emailReg.test(this.shareEmail)) {
        this.shareEmail = ''
      }
    },
    shareDriver() {
      this.shareEmailTip = true
      if (!this.shareEmail) {
        return false
      }
      this.api.param = {
        "THBillNO": this.curTH,
        "ShareEmail": this.shareEmail,
        "Remark": this.Note
      }
      this.api.url = this.$api03 + "/api/TradeCustomer/THOrder/DriverShare";
      post(this.api.url, this.api.param).then(res => {
        if (res.IsOK) {
          this.$alert('successfully', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            center: true
          }).then(() => {
            this.share = false
            this.shareEmailTip = false
          }).catch(() => {
            this.share = false
            this.shareEmailTip = false
          });
        }
      });
    },
    //关闭分享弹窗，清除输入框数据
    ColseBtn() {
      this.shareEmail = ''
      this.Note = ''
      this.shareEmailTip = false
    },

  },
}



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/pickup/pickUpList.js